import { SingleFindEvent } from "../../../redux/features/event/event.types";

const parseDateOnly = (date?: string) => {
  if (!date) return undefined;

  const dateOnly = date.split("T")[0];
  const parsedDate = new Date(`${dateOnly}T00:00:00`);

  return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate;
};

export const hasEventEnded = (
  event: Pick<SingleFindEvent, "endDate" | "startDate">,
  now = new Date(),
) => {
  const eventDate =
    parseDateOnly(event.endDate) ?? parseDateOnly(event.startDate);
  if (!eventDate) return false;

  const today = new Date(now);
  today.setHours(0, 0, 0, 0);

  return eventDate < today;
};

export const getEarliestTrendingEvents = (
  events: SingleFindEvent[] = [],
  now = new Date(),
) => {
  return events
    .filter(
      (event) =>
        event.isTrending &&
        event.status === "upcoming" &&
        !hasEventEnded(event, now),
    )
    .sort((a, b) => {
      const aTime = new Date(a.startDate).getTime();
      const bTime = new Date(b.startDate).getTime();

      return aTime - bTime;
    });
};
